const empStatusList = [
    { 'key': 'Deactive', 'value': 0 },
    { 'key': 'Active', 'value': 1 },
    { 'key': 'Resigned', 'value': 2 }
]

const batchNoList = ['batch1','batch2','batch3','batch4','batch5','batch6','batch7','batch8','batch9','batch10']

const trStatusList = [
    { 'key': 'Rejected', 'value': 0 },
    { 'key': 'Approved', 'value': 1 },
    // { 'key': 'Pending', 'value': 2 },
    { 'key': 'Not Initiated', 'value': 2 },
    { 'key': 'Non Promoted', 'value': 4 },
    { 'key': 'Promoted', 'value': 5 },
    { 'key': 'Continued', 'value': 6 }
]

const addResourceAllColumnList = [
    { item_id: 1, slug: 'empCode', item_text: 'Emp. Code' },
    { item_id: 2, slug: 'userName', item_text: 'Emp. Name' },
    { item_id: 3, slug: 'email', item_text: 'Email Id' },
    { item_id: 4, slug: 'currentPosition', item_text: 'Current Role' },
    { item_id: 5, slug: 'nextPosition', item_text: 'Next Role' },
    { item_id: 6, slug: 'empStatus', item_text: 'Emp Status' },
    { item_id: 7, slug: 'batchNo', item_text: 'Batch Number' },
    { item_id: 8, slug: 'journeyCompletionDate', item_text: 'Journey Completion Date' },
    { item_id: 9, slug: 'isApproved', item_text: 'Status' },
    { item_id: 10, slug: 'approvedAt', item_text: 'Nominated At' },
    { item_id: 10, slug: 'userId', item_text: 'Notes' }
  ];

  const addResourceColumnList = [
    { item_id: 1, slug: 'empCode', item_text: 'Emp. Code' },
    { item_id: 2, slug: 'userName', item_text: 'Emp. Name' },
    { item_id: 4, slug: 'currentPosition', item_text: 'Current Role' },
    { item_id: 5, slug: 'nextPosition', item_text: 'Next Role' },
    { item_id: 6, slug: 'empStatus', item_text: 'Emp Status' },
    { item_id: 9, slug: 'isApproved', item_text: 'Status' }
  ];

export const ConstantValue = {
    EmpStatusList: empStatusList,
    BatchNoList: batchNoList,
    TrStatusList: trStatusList,
    AddResourceColumns: addResourceColumnList,
    AddResourceAllColumnList: addResourceAllColumnList
}